import styled from "styled-components";
import Variables from "../../assets/styleVariables";
export const Box = styled.div`
  width: 50px;
  height: 30px;
  position: relative;
  transition: 0.3s all;
  cursor: pointer;
  opacity: ${props => (props.disable ? "0.5" : "1")};
  &:before {
    transition: 0.3s all;
    width: 45px;
    height: 16px;
    border-radius: 8px;
    display: block;
    content: "";
    position: absolute;
    top: 8px;
    right: 2.5px;
  }
  &:after {
    transition: 0.3s all;
    content: "";
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 25px;
    box-shadow: 0 0 2px 0 #cccccc;
    top: 3px;
  }
  ${props => {
    if (props.status) {
      return `
            &:before {
              background-color: ${Variables.colors.primary_400};
              opacity: 0.4;
            }
            &:after {
              border: solid 1px ${Variables.colors.primary_400};
              background-color: ${Variables.colors.primary_vivid};
              right: 0;
            }
        `;
    } else {
      return `
            &:before {
              background-color: ${Variables.colors.complementary_500};
              opacity: 0.6;
            }
            &:after {
              border: solid 1px #d7d7d7;
              background-color: ${Variables.colors.complementary};
              right: 25px;
            }
        `;
    }
  }}
`;
